import { RecordedInterviewSystemStatus, ISummaryRecordedInterview } from 'types';

export const getActiveRecordedInterviews = (
  recordedInterviews: ISummaryRecordedInterview[],
): ISummaryRecordedInterview[] => {
  return recordedInterviews.filter(
    (interview: ISummaryRecordedInterview) =>
      interview.systemStatus !== RecordedInterviewSystemStatus.DELETED &&
      interview.systemStatus !== RecordedInterviewSystemStatus.FAILED &&
      interview.systemStatus !== RecordedInterviewSystemStatus.RESIT &&
      interview.systemStatus !== RecordedInterviewSystemStatus.PASSED,
  );
};
